import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';

import { initAxiosRetry, createAxiosResponseInterceptor } from '@/store/configDefaultAPI';

import './configImmer';

// Reducers
import auth from './reducers/auth.ts';
import reports from './reducers/reports.ts';
import srUsers from './reducers/srUsers';
import users from './reducers/users';
import profiles from './reducers/profiles';
import dictionary from './reducers/dictionary';
import charts from './reducers/charts';
import wpBlog from './reducers/wpBlog';
import webhooks from './reducers/webhooks';
import settings from './reducers/settings';

import rootReducer from './reducers/index.ts';
import rootSaga from './saga';

// initAxiosRetry
initAxiosRetry();
// create Interceptor
createAxiosResponseInterceptor();

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: {
    // Need to change to (reducer: rootReducer) after all will be changed to slice approach
    ...rootReducer,
    auth,
    reports,
    srUsers,
    users,
    profiles,
    dictionary,
    charts,
    wpBlog,
    webhooks,
    settings,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActionPaths: ['payload.onSuccess'],
      },
    }).concat(sagaMiddleware),
  devTools: import.meta.env.MODE !== 'production',
});

sagaMiddleware.run(rootSaga);

export default store;
